import Link from 'next/link';

export default function Breadcrumbs(props) {
  return (
    <nav className={props.className} cy-test-id="breadcrumbs">
      <ul>
        {props.items.map((i, j) => (
          <li key={j} className="inline text-[13px] text-gray-500">
            {i.url !== undefined && (
              <Link className="hover:text-white" href={i.url}>
                {i.label}
              </Link>
            )}
            {i.url === undefined && <span className="">{i.label}</span>}
            {j !== props.items.length - 1 && (
              <svg
                className="inline mx-2"
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.91016 2.25L8.66016 6L4.91016 9.75"
                  stroke="#7F898D"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}
